import * as http from '@/utils/request';

const uploadConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  }
}
export const loginAPI = {
  /* 登录
   * @param {Object} query
   * @param {String} query.username 用户名
   * @param {String} query.password 密码
  */
  login(query) {
    return http.post(`/auth/login`, query)
  },
  

  // 修改密码
  resetPassword(query){
    return http.put(`/auth/update/password`,query)
  }
 

}